'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function InboxEvents() {
  const router = useRouter()

  useEffect(() => {
    const events = new EventSource('/api/inbox/events')

    events.addEventListener('new-ticket', () => {
      router.refresh()
    })

    return () => events.close()
  }, [router])

  return null
}
